import {
    isApiError,
    showApiErrorToast,
    showApiErrorToastWithMessage,
} from '@fifa-bsm/bo-frontend-shared/utils';

export const createShowErrorToastInterceptor = (toastService) => {
    const errorHandler = (error) => {
        if (!isApiError(error) || error.config.showErrorToast === false) {
            return Promise.reject(error);
        }

        const toasts = typeof toastService === 'function' ? toastService() : toastService;

        if (typeof error.config.showErrorToast === 'function') {
            showApiErrorToastWithMessage(toasts, error.config.showErrorToast(error));
        } else {
            showApiErrorToast(toasts, error);
        }

        return Promise.reject(error);
    };

    return {
        successHandler: (response) => response,
        errorHandler,
    };
};
